module.exports = __webpack_public_path__ + "static/media/git--gud-A-green.2eff5f8a.svg";